import { useBreadcrumb } from "features/breadcrumbs";
import ListarImpostos from "./components/ListarImpostos/index";

function ImpostosListagemPage() {
  useBreadcrumb([
    { name: "Financeiro" },
    { name: "Impostos", url: "/financeiro/impostos" },
  ]);

  return <ListarImpostos />;
}

export default ImpostosListagemPage;
